/**
 * ClarityPrompt.jsx - DEPRECATED STUB
 * 
 * GRANULLO_COMMITMENT_INFRASTRUCTURE_v1.0
 * 
 * Clarity Mode has been superseded by the Commitment Object model.
 * This component is disabled pending implementation of the new
 * "Explain" toggle (simpler, copy-only orientation layer).
 * 
 * The original implementation is preserved in git history.
 * Returns null to prevent UI interference.
 */

import React from 'react';

/**
 * ClarityPrompt - DEPRECATED
 * Returns null to disable the ambient Clarity Mode prompt.
 */
export const ClarityPrompt = () => {
  // DISABLED: Clarity Mode deprecated
  // Superseded by Explain Toggle (to be implemented)
  return null;
};

export default ClarityPrompt;
